import { Button } from 'components/ui'
import { APPSUMO_CODES_URL, APPSUMO_STUDIO_URL } from 'components/ui/utils/constant'
import { HiOutlineExternalLink } from 'react-icons/hi'
import React, { useContext } from 'react'
import { AppSumoContext } from 'contexts/AppSumoContext'
import { HiPlusCircle } from 'react-icons/hi2'

export default function AppSumoUpgradeButton({ collapsed = false, variant = 'codes' }) {

    const { getTier, getLicenseTier } = useContext(AppSumoContext);

    const isStudio = variant === 'studio';
    const href = isStudio ? APPSUMO_STUDIO_URL : APPSUMO_CODES_URL;

    const label = isStudio
        ? `Upgrade License → Tier ${parseInt(getLicenseTier()) + 1}`
        : `Upgrade to Tier ${parseInt(getTier()) + 1}`;

    const accentClass = isStudio ? 'bg-fuchsia-400' : 'bg-yellow-400';

    return (
        <Button
            variant="solid"
            size="sm"
            className={`relative !rounded-lg bg-black hover:bg-gray-900 text-white font-semibold overflow-hidden transition-all duration-300 transform hover:scale-105 hover:shadow-lg border border-gray-700 ${collapsed ? `!w-[76%] !ml-[12%] !px-0` : `w-full`}`}
            onClick={() => window.open(href, '_blank', 'noopener,noreferrer')}
        >
            {/* Background decorative shapes */}
            <div className="absolute inset-0 opacity-10">
                <div className={`absolute top-0 right-0 w-16 h-16 ${accentClass} rounded-full transform translate-x-8 -translate-y-8`}></div>
                <div className={`absolute bottom-0 left-0 w-12 h-12 ${accentClass} rounded-full transform -translate-x-6 translate-y-6`}></div>
                <div className={`absolute top-1/2 left-1/4 w-8 h-8 ${accentClass} rounded-full transform -translate-y-1/2 opacity-50`}></div>
            </div>

            {/* Gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-r from-black via-gray-900 to-black opacity-90"></div>

            {/* Content */}
            <div className={`relative flex items-center ${collapsed ? `justify-center` : `justify-between`} gap-2`}>
                <div className="flex items-center gap-2">
                    <div className="relative shrink-0">
                        <img
                            src="/img/others/appsumo.webp"
                            alt="AppSumo"
                            className={`w-5 !h-auto`}
                        />
                        {!!collapsed && (
                            <HiPlusCircle className="!text-xs text-white absolute -top-0.5 -left-0.5" />
                        )}
                    </div>
                    {!collapsed && (
                        <span className="text-xs font-semibold">
                            {label}
                        </span>
                    )}
                </div>
                {!collapsed && (
                    <HiOutlineExternalLink className="w-4 h-4 text-gray-300 ml-1" />
                )}
            </div>

            {/* Shine effect on hover */}
            <div className="absolute inset-0 opacity-0 hover:opacity-100 transition-opacity duration-300">
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-10 transform -skew-x-12 translate-x-full group-hover:-translate-x-full transition-transform duration-700"></div>
            </div>
        </Button>
    )
}
